module.exports = __webpack_public_path__ + "static/img/dual-ball.ba5538a4.svg";